import { Component, Input, OnInit } from '@angular/core';
import { Acesso } from '../../../../core/acesso';
import { AcoesPlanejamentoOficina } from '../../../../core/acoes-planejamento-oficinas';
import { MetaAcao } from '../../../../core/meta-acao';
import { PlanejamentoOficina } from '../../../../core/planejamento-oficina';
import { DataUtilService } from '../../../../services/commons/data-util.service';

@Component({
    selector: 'cadastrar-acoes-planejamento-oficina',
    templateUrl: './cadastrar-acoes-planejamento-oficina.component.html',
    styleUrls: ['./cadastrar-acoes-planejamento-oficina.component.css']
})
export class CadastrarAcoesPlanejamentoOficinaComponent implements OnInit {

    @Input() perfilAcesso: Acesso;

    @Input() planejamentoOficina: PlanejamentoOficina;
    acaoPlanejamentoOficina: AcoesPlanejamentoOficina = new AcoesPlanejamentoOficina();
    metasAcoes: MetaAcao[] = [];


    listaLocalExecucao: any[] = [
        {tipo: 'Interna', flag: 'I'},
        {tipo: 'Externa', flag: 'E'}
    ];

    isAtualizar = false;

    constructor(private dataUtilService: DataUtilService) {
    }

    ngOnInit() {
        this.zerarCombos
    }

    zerarCombos() {
        this.acaoPlanejamentoOficina = new AcoesPlanejamentoOficina();
        this.acaoPlanejamentoOficina.metas = [];
    }

    adicionar() {
        const acaoPlanejamentoOficina = new AcoesPlanejamentoOficina();
        Object.assign(acaoPlanejamentoOficina, this.acaoPlanejamentoOficina);

        if (!this.planejamentoOficina.acoesPlanejamentoOficina) {
            this.planejamentoOficina.acoesPlanejamentoOficina = [];
        }

        acaoPlanejamentoOficina.dataInicio = this.dataUtilService.getDataTruncata(this.acaoPlanejamentoOficina.dataInicio);

        if (acaoPlanejamentoOficina.metas)
            acaoPlanejamentoOficina.metas = acaoPlanejamentoOficina.metas.filter(meta => meta.metaObjetivo?.id);

        this.planejamentoOficina.acoesPlanejamentoOficina.push(acaoPlanejamentoOficina);

        this.zerarCombos();
    }

    atualizar() {
        this.acaoPlanejamentoOficina.dataInicio = this.dataUtilService.getDataTruncata(this.acaoPlanejamentoOficina.dataInicio);
        if (this.acaoPlanejamentoOficina.metas)
            this.acaoPlanejamentoOficina.metas = this.acaoPlanejamentoOficina.metas.filter(meta => meta.metaObjetivo?.id);

        const index = this.planejamentoOficina.acoesPlanejamentoOficina.indexOf(this.planejamentoOficina.acoesPlanejamentoOficina.find(col => col.id === this.acaoPlanejamentoOficina.id));
        this.planejamentoOficina.acoesPlanejamentoOficina.splice(index, 1, this.acaoPlanejamentoOficina);

        this.isAtualizar = false;
        this.zerarCombos();
    }

    atualizarAcaoPlanejamentoOficina(acaoPlanejamentoOficina: AcoesPlanejamentoOficina) {
        this.isAtualizar = true;
        this.acaoPlanejamentoOficina = acaoPlanejamentoOficina;
        this.metasAcoes.push(...acaoPlanejamentoOficina.metas);
    }

    cancelar() {
        this.zerarCombos();
        this.isAtualizar = false;
    }

    onMascaraDataInput(event) {
        return this.dataUtilService.onMascaraDataInput(event);
    }

    addMeta() {
        if (!this.acaoPlanejamentoOficina.metas) {
            this.acaoPlanejamentoOficina.metas = [];
        }

        const meta: MetaAcao = new MetaAcao();
        meta.id = undefined;
        this.acaoPlanejamentoOficina.metas.push(meta);
        this.metasAcoes.push(meta);
    }

}
